// extracted by mini-css-extract-plugin
export var readonly = "_ev-1";
export var star = "_ev-0";